import { isAfter, isBefore } from "date-fns"
import { IsValidCheck } from "./types"

export const isOffCoverWithinPolicyDatesError = `Off cover date must be within policy dates`
export const isOffCoverWithinPolicyDates: IsValidCheck = (entry, _, policyDuration) => {
  if (!policyDuration?.startTime || !policyDuration?.endTime || !entry.offCoverDate) return undefined

  const policyStart = new Date(policyDuration.startTime)
  const policyEnd = new Date(policyDuration.endTime)
  const offCoverDate = new Date(entry.offCoverDate)
  return !isBefore(offCoverDate, policyStart) && !isAfter(offCoverDate, policyEnd)
}
